import React from 'react';
import { FormField, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { LAST_MONTH_RENT } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function LastMonthRent({ section, setSectionValues }: Props): JSX.Element {
  function onNoLastMonth(): void {
    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesLastMonth(): void {
    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      required
      label={<Label>Will you collect the last month’s rent before move-in?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesLastMonth}
          noHandler={onNoLastMonth}
          yesActive={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED)}
        />
      }
    />
  );
}
